namespace GeniuzPOS.Administration {
    export interface PsBizTypesForm {
        BizType: Serenity.StringEditor;
        BizTypeName: Serenity.StringEditor;
    }

    export class PsBizTypesForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.PsBizTypes';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsBizTypesForm.init)  {
                PsBizTypesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PsBizTypesForm, [
                    'BizType', w0,
                    'BizTypeName', w0
                ]);
            }
        }
    }
}
